import { computed } from 'ccstate'
import { supabaseCurrentUser$ } from '../infra/authClient'

const currentUser$ = computed(async (get) => {
  return await get(supabaseCurrentUser$)
})

const isLoggedIn$ = computed(async (get) => {
  const user = await get(currentUser$)
  return user.isLoggedIn
})

const userEmail$ = computed(async (get) => {
  const user = await get(currentUser$)
  return user.email
})

const userAvatarUrl$ = computed(async (get) => {
  const user = await get(currentUser$)
  return user.avatarUrl || ''
})

export const sharedCurrentUserState = {
  currentUser$,
  isLoggedIn$,
  userEmail$,
  userAvatarUrl$,
}